import React, { PureComponent, ReactNode } from 'react'
import { Page } from '../../../components'

class DetailsFullscreenMap extends PureComponent {
  public render(): ReactNode {
    return (
      <Page>
        DetailsFullscreenMap
      </Page>
    )
  }
}

export default DetailsFullscreenMap
